import React from 'react';
import {
  Box,
  Dialog,
  Tooltip,
  TextField,
  Typography,
  IconButton,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import { AttachFile, Delete } from '@material-ui/icons';
import { ThemeProvider } from '@material-ui/core/styles';
import {
  Transition, Button, useStyles, theme,
} from './styles';

const ResultsDialog = (props) => {
  const {
    form,
    openDialog,
    onCloseDialog,
    onSubmitResult,
    onChangeInputs,
    onDeleteFile,
  } = props;

  const classes = useStyles();
  return (
    <Dialog
      fullWidth
      keepMounted
      maxWidth="xs"
      open={openDialog}
      onClose={onCloseDialog}
      TransitionComponent={Transition}
    >
      <Box
        component="form"
        onSubmit={(e) => {
          onSubmitResult(e);
          onCloseDialog();
        }}
      >
        <DialogContent>
          <ThemeProvider theme={theme}>
            <TextField
              value={form.resultado || ''}
              onChange={(e) => onChangeInputs(e.target.value, 'resultado')}
              required
              fullWidth
              label="Resultados"
              variant="outlined"
              multiline
              minRows={6}
            />
          </ThemeProvider>
          <Box>
            {form.adjuntos?.map((file, index) => (
              <Box key={file.name} className={classes.filesContainer}>
                <Typography className={classes.fileName}>
                  {file.nombreAdjunto}
                </Typography>
                <IconButton onClick={() => onDeleteFile(index)}>
                  <Delete fontSize="small" />
                </IconButton>
              </Box>
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Adjuntar archivo">
            <IconButton component="label" variant="contained">
              <AttachFile />
              <input
                type="file"
                hidden
                onChange={(e) => {
                  onChangeInputs(e.target.files, 'files');
                }}
              />
            </IconButton>
          </Tooltip>
          <Button type="button" onClick={onCloseDialog}>Cancelar</Button>
          <Button type="submit">Enviar</Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default ResultsDialog;
